import forcedIcon from "@rosette/assets/src/icons/analysis/forced.svg";
import brilliantIcon from "@rosette/assets/src/icons/analysis/brilliant.svg";
import greatIcon from "@rosette/assets/src/icons/analysis/great.svg";
import bestIcon from "@rosette/assets/src/icons/analysis/best.svg";
import excellentIcon from "@rosette/assets/src/icons/analysis/excellent.svg";
import goodIcon from "@rosette/assets/src/icons/analysis/good.svg";
import mistakeIcon from "@rosette/assets/src/icons/analysis/mistake.svg";
import blunderIcon from "@rosette/assets/src/icons/analysis/blunder.svg";
import { MoveCategory } from "@rosette/ts/src/business/analysis/MoveCategory.js";


export function getMoveCategoryIcon(moveCategory: MoveCategory) {
    if (moveCategory === MoveCategory.WIN)
        return bestIcon;
    if (moveCategory === MoveCategory.FORCED)
        return forcedIcon;
    if (moveCategory === MoveCategory.BRILLIANT)
        return brilliantIcon;
    if (moveCategory === MoveCategory.EXCELLENT)
        return excellentIcon;
    if (moveCategory === MoveCategory.BEST)
        return bestIcon;
    if (moveCategory === MoveCategory.GREAT)
        return greatIcon;
    if (moveCategory === MoveCategory.GOOD)
        return goodIcon;
    if (moveCategory === MoveCategory.MISTAKE)
        return mistakeIcon;
    if (moveCategory === MoveCategory.BLUNDER)
        return blunderIcon;

    throw new Error(`Unknown move category ${moveCategory.id}`);
}
